export default __webpack_public_path__ + "static/media/SaleBanner.ddb29e05.png";